<template>
  <transition
    enterClass='opacity-0 -mb-6'
    enterActiveClass='transition-all transform duration-300'
    enterToClass='opacity-100 mb-0'
    leaveClass='opacity-100 mb-0'
    leaveActiveClass='transition-all transform duration-300'
    leaveToClass='opacity-0 translate-x-full'
    @before-enter="beforeEnter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
    @after-leave="afterLeave"
  >
    <div
      v-if="show"
      class="notify overflow-hidden w-80 relative pointer-events-auto"
      :class="[
        type ? type : ''
      ]"
    >
      <div class="overflow-hidden bg-white dark:bg-primary-900 dark:text-white shadow mb-2 p-4 rounded flex relative">
        <button
          v-if="closeButton"
          type="button"
          class="notify-close absolute right-0 top-0 w-8 h-8 flex justify-center items-center"
          role="button"
          @click="hideNotify"
        >
          <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <div
          v-if="progressBar"
          class="notify-progress absolute left-0 bottom-0 top-auto h-0 pt-1 bg-primary-600"
          :style="'width: ' + progress.percent + '%'"
        />

        <div class="notify-content">
          <div class="notify-title font-bold mb-2">
            {{ title }}
          </div>
          <div class="notify-message text-sm">
            {{ message }}
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'Notify',
  props: {
    type: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      default: 'bottom left'
    },
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    closeButton: {
      type: Boolean,
      default: true
    },
    progressBar: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    showMethod: {
      type: String,
      default: 'fade in'
    },
    hideMethod: {
      type: String,
      default: 'fade out'
    },
    duration: {
      type: Number,
      default: 10000
    },
    showDuration: {
      type: Number,
      default: 0
    },
    hideDuration: {
      type: Number,
      default: 0
    },
    delay: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      progress: {
        hideEta: 0,
        percent: 0,
        intervalId: null
      },
      show: false
    }
  },
  computed: {
    positionClass () {
      return this.position.split(' ').join('-')
    }
  },
  beforeMount () {
    let toastContainer = document.querySelector(`.notify-container.${this.positionClass}`)
    if (!toastContainer) {
      toastContainer = document.createElement('div')
      toastContainer.classList.add('notify-container')
      toastContainer.classList.add(`${this.positionClass}`)
      document.body.appendChild(toastContainer)
    }
    toastContainer.appendChild(this.$el)
  },
  mounted () {
    setTimeout(() => this.showNotify(), this.delay)
  },
  methods: {
    showNotify () {
      this.show = true
      if (this.duration !== 0) {
        this.sto = setTimeout(() => this.hideNotify(), this.duration)
        if (this.progressBar) {
          this.progress.hideEta = new Date().getTime() + parseFloat(this.duration)
          this.progress.intervalId = setInterval(() => this.refreshProgress(), 10)
        }
      }
    },
    hideNotify () {
      clearTimeout(this.sto)
      clearTimeout(this.progress.intervalId)
      this.show = false
    },
    refreshProgress () {
      this.progress.percent = ((this.progress.hideEta - (new Date().getTime())) / this.duration) * 100
    },
    beforeEnter (el) {
      if (this.showDuration) {
        //el.style.animationDuration = this.showDuration + 's'
      }
    },
    afterEnter (el) {
      // this.showMethod
      // let classesToAdd = [ 'animation', 'fade', 'in', 'right' ]
      // this.$el.classList.add(classesToAdd)
    },
    beforeLeave (el) {
      this.$el.style.zIndex = 0
      if (this.hideDuration) {
        //el.style.animationDuration = this.hideDuration + 's'
      }
    },
    afterLeave (el) {
    }
  }
}

</script>
